import { FC } from 'react'
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom'
import {
  AtendimentoType,
  IconPaths,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '_metronic/helpers'
import { RowActions, useModal, useToast } from 'app/components'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { ProfissionalValoresModal } from '../../components/modal/ProfissionalValoresModal'
import { deleteValoresByProfissional, getValoresProfissionalByValor } from '../../core/_requests'
import { ValorProfissionalDtoRemover, ValorProfissionalList } from '../../core/_models'

type Props = {
  valorProfissional: ValorProfissionalList
}

export const ProfissionalValoresActionCell: FC<Props> = ({ valorProfissional }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { id } = useParams<{ id: string }>()
  const { refetch } = useQueryResponse()

  const nome = [valorProfissional.tipo, valorProfissional.especialidade?.nome]
    .filter(Boolean)
    .join(' · ')

  const openEditModal = () =>
    showModal({
      title: 'Editar valor',
      content: <ProfissionalValoresModal idProfissional={Number(id)} />,
      fetchers: {
        valorProfissional: () => getValoresProfissionalByValor(Number(id), valorProfissional.id),
      },
    })

  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir valor?',
      text: `O valor de ${nome || 'atendimento'} será excluído.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      const data: ValorProfissionalDtoRemover = {
        tipo: valorProfissional.tipo as AtendimentoType,
        especialidades: valorProfissional.especialidade
          ? [valorProfissional.especialidade.id]
          : null,
      }
      await deleteValoresByProfissional(Number(id), data)
      Swal.close()
      showToast({ variant: 'success', title: 'Valor excluído.' })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={`valor de ${nome || 'atendimento'}`}
      primaryAction={{ label: 'Editar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
